import * as React from 'react'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import RolesPermissions from '@/pages/rolesPermissionsAdmin/RolesPermissionsAdmin.page'

export const Route = createFileRoute('/_auth/permissions')({
  // component: () => <IFramePage url="roles-crud.html" />,
  component: () => <PermissionsLayout />,
})

const PermissionsLayout = () => {
  return (
    <>
      <RolesPermissions />
      <Outlet />
    </>
  )
}
